/**
 * Shared helpers for sensitive species (global and sensitive-at-site).
 * Use these so "sensitive at site" is treated like all other sensitive species.
 */

export const SPECIES_SENSITIVE_KEYS = [
  'isSensitive',
  'IsSensitive',
  'is_sensitive',
  'sensitiveSpecies',
  'SensitiveSpecies',
  'sensitive_species',
  'globallySensitiveSpecies',
  'GloballySensitiveSpecies',
  'globally_sensitive_species',
  'sensitiveAtSite',
  'SensitiveAtSite',
  'sensitive_at_site',
  'hiddenSensitive',
  'HiddenSensitive',
  'hidden_sensitive'
]

export const parseSensitiveFlag = (value) => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'number') {
    return value > 0
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    if (normalized === 'true' || normalized === '1' || normalized === 'yes') {
      return true
    }
    if (normalized === 'false' || normalized === '0' || normalized === 'no') {
      return false
    }
  }
  return undefined
}

/**
 * Returns true if the species is considered sensitive (globally or at site).
 * Use this everywhere so sensitive_at_site is treated like other sensitive species.
 */
export const isSpeciesSensitive = (specie) => {
  return SPECIES_SENSITIVE_KEYS.some((key) => parseSensitiveFlag(specie?.[key]) === true)
}

const hasLegacyGlobalSensitivitySource = (specie) => {
  const source = specie?.sensitive_at_site_source ?? specie?.sensitiveAtSiteSource

  if (typeof source !== 'string') {
    return false
  }

  return source.trim().toLowerCase() === 'global'
}

/**
 * True when the species is globally sensitive (IUCN flag or legacy global source).
 */
export const isGloballySensitiveSpecies = (specie) => {
  if (parseSensitiveFlag(specie?.sensitiveSpecies) === true) {
    return true
  }

  if (parseSensitiveFlag(specie?.SensitiveSpecies) === true) {
    return true
  }

  if (parseSensitiveFlag(specie?.globallySensitiveSpecies) === true) {
    return true
  }

  if (parseSensitiveFlag(specie?.GloballySensitiveSpecies) === true) {
    return true
  }

  return hasLegacyGlobalSensitivitySource(specie)
}
